import { render, staticRenderFns } from "./RosettesQuizPopup.vue?vue&type=template&id=07ac3e4b&scoped=true&"
import script from "./RosettesQuizPopup.vue?vue&type=script&lang=js&"
export * from "./RosettesQuizPopup.vue?vue&type=script&lang=js&"
import style0 from "./RosettesQuizPopup.vue?vue&type=style&index=0&id=07ac3e4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ac3e4b",
  null
  
)

export default component.exports